<script setup lang="ts">
import { storeToRefs } from 'pinia';
import PaymentCard from './PaymentCard.vue';
import ApplePay from '@/dashboard/vue/components/icons/payment/ApplePay.vue';
import GooglePay from '../../icons/payment/GooglePay.vue';
import PaypalPay from '../../icons/payment/PaypalPay.vue';
import MasterCardPay from '../../icons/payment/MasterCardPay.vue';
import VisaPay from '../../icons/payment/VisaPay.vue';
import MaestroPay from '../../icons/payment/MaestroPay.vue';
import AmericanExpressPay from '../../icons/payment/AmericanExpressPay.vue';
import { usePurchaseStore } from '@/dashboard/store/purchaseStore';
import PaymentCardContacts from '@/dashboard/vue/components/popups/PaymentPopup/paymentCardContacts.vue';

const purchaseStore = usePurchaseStore();

const { period } = storeToRefs(purchaseStore);
</script>

<template>
  <div class="w-[1197px]">
    <div class="flex w-full flex-col px-xl pt-m">
      <div class="mb-m flex flex-1 items-center justify-between">
        <span class="text-content-xl text-black dark:text-white">Choose the best plan for you</span>
        <div class="mt-xxs flex items-center">
          <span class="text-caption-s mr-[12px] text-black dark:text-white">Annually</span>
          <label class="tppr-switch" @click="() => purchaseStore.switchPeriod()">
            <span class="tppr-switch__input" :class="{ checked: period === 'year' }" />
            <span class="tppr-switch__presenter">
              <span class="tppr-switch__presenter__circle" />
            </span>
          </label>
        </div>
      </div>

      <div class="mb-[41px] flex gap-l">
        <PaymentCard :type="'basic'" />
        <PaymentCard :type="'pro'" />
        <PaymentCardContacts />
      </div>

      <div class="mb-[28px] flex items-center justify-center gap-xl">
        <ApplePay />
        <GooglePay />
        <PaypalPay />
        <MasterCardPay class="rounded-4 shadow-[0px_0.78px_1.8px_0px_rgba(0,0,0,0.07)]" />
        <VisaPay class="rounded-4 shadow-[0px_0.78px_1.8px_0px_rgba(0,0,0,0.07)]" />
        <MaestroPay class="rounded-4 shadow-[0px_0.78px_1.8px_0px_rgba(0,0,0,0.07)]" />
        <AmericanExpressPay class="rounded-4 shadow-[0px_0.78px_1.8px_0px_rgba(0,0,0,0.07)]" />
      </div>

      <div class="mb-m flex flex-col items-center gap-[20px] text-center">
        <span class="text-[15px] tracking-[-0.2px] text-gray-450 dark:text-gray-500">And Discover, Diners Club, JCB, UnionPay, Mada</span>

        <button @click="() => purchaseStore.closePopup()">
          <span class="text-caption-s text-gray-500 underline underline-offset-[2px] dark:text-gray-650">I'll do it later</span>
        </button>
      </div>
    </div>
  </div>
</template>
